// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"565":"nine-box","884":"am","916":"diarios"}[chunkId] || chunkId) + "." + {"565":"6bbbb2dd","629":"cd21e849","636":"e0b59052","884":"6a74e66b","916":"b0273f24"}[chunkId] + ".css";
};